import React, { useContext, useMemo, useState } from "react";

import {useNavigate} from 'react-router-dom';


import './ProcsProgramadosList.css';

import { faCheck, faSpinner, faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalForm from "../modalForm/ModalForm";
import controlContext from "../../context/control/controlContext";
import activoContext from "../../context/activoContex/activoContex";
import checklistContext from "../../context/checklistContext/checklistContext";
import authContext from "../../context/authentication/authContex";
import Swal from "sweetalert2";
import normalizeText from "../../utils/normalizeText";
import { deleteProcProgramado, checkProcProgramado } from "../../api/activo";


const ProcsProgramadosList = ({procsProgramados, setProcsProgramados, filter, checkIfAdmin, checkIfAdminOrAdminNoABMs, ordenesTrabajoFromLocalStorage, checklistRegFromLocalStorage}) => {

    const navigate = useNavigate();
    const [procCtrlsFallidos,setProcCtrlsFallidos] = useState({});
    const [procsToCreateODT,setProcsToCreateODT] = useState([]);

    const {listTDoc} = useContext(controlContext);
    const {globalSettings} = useContext(authContext);
    const {checklistRegList} = useContext(checklistContext);

    const procProgramadosFiltered = useMemo(()=> procsProgramados.filter((p) => {
        return (filter != '') ? 
            (filter.charAt(0) == '"' && filter.charAt(filter.length - 1) == '"') ?
                (normalizeText(p.codProc) == normalizeText(filter.replaceAll('"','')) || normalizeText(p.nameProcedimiento) == normalizeText(filter.replaceAll('"','')) || normalizeText(p.nameActivo) == normalizeText(filter.replaceAll('"','')) || normalizeText(p.codActivo) == normalizeText(filter.replaceAll('"','')))
                :
                (normalizeText(p.codProc).includes(normalizeText(filter)) || normalizeText(p.nameProcedimiento).includes(normalizeText(filter)) || normalizeText(p.nameActivo).includes(normalizeText(filter)) || normalizeText(p.codActivo).includes(normalizeText(filter))) 
        : 
        true
    }),[procsProgramados, filter]);

    const generarOT = async (p,action) => {
        if(p.originado == 'CHECKLIST' && action == 'new'){
            try {
                const res = await checkProcProgramado(p._id);
                if(!res.data.exists){
                    setProcsProgramados(prev => prev.filter(proc => proc._id !== p._id));
                    Swal.fire({title:'Ops!', text:'Otro administrador estableció que este checklist no disparará procedimientos.', icon:'error'});
                    return;
                }
                const updatedProc = res.data.data;
                if(updatedProc.NroForOT > 0){
                    setProcsProgramados(prev => prev.map(proc => proc._id === p._id ? updatedProc : proc));
                    Swal.fire({title:'Una orden de trabajo ya se generó sobre este procedimiento', text:'Parece que alguien ya tomó medidas sobre este procedimiento! Actualizando procedimiento....', icon:'info'});
                    return;
                }
            } catch (error) {
                return;
            }
        }
        if(p.nroChecklistReg != undefined && p.nroChecklistReg != 0){
            if(action == 'new') setProcCtrlsFallidos(p);
            else if(action == 'edit') navigate('/home',{state:{NroForOT:p.NroForOT,editOT:'fromProcProgramado'}});
        }else{
            if(action == 'new'){
                if(procsToCreateODT.length > 1 && procsToCreateODT.some(proc => proc._id == p._id)) navigate('/addReq',{state:{procedimientos: procsToCreateODT}});
                else navigate('/addReq',{state:{procedimiento: p}});
            }
            else if(action == 'edit') navigate('/home',{state:{NroForOT:p.NroForOT,editOT:'fromProcProgramado'}});
        }
    }

    const visualizarOT = (p) => {
        if(globalSettings?.openNewtab){
            //Setea la OT por la que se filtraran las ordenes de trabajo.
            localStorage.setItem('OTtoFind',`"${p.CodForOT} - ${p.NroForOT}"`);
            
            localStorage.setItem('ordenesTrabajo',(ordenesTrabajoFromLocalStorage && ordenesTrabajoFromLocalStorage != 'null') ? ordenesTrabajoFromLocalStorage : JSON.stringify(listTDoc));
            
            localStorage.setItem('checklistsReg', (checklistRegFromLocalStorage && checklistRegFromLocalStorage != 'null') ? checklistRegFromLocalStorage : JSON.stringify(checklistRegList));
            
            //Abre en una pestaña nueva la vista especificada (Procedimientos o Documentos).
            window.open(`${window.location.origin}/Home`, "_blank");
        }else{
            navigate('/Home',{state:{OTtoFind: `"${p.CodForOT} - ${p.NroForOT}"`}})
        }
    }

    const visualizarChecklist = (p) =>{
        if(globalSettings?.openNewtab){
            localStorage.setItem('CKtoFind',`"${p.codChecklistReg} - ${p.nroChecklistReg}"`);
            localStorage.setItem('checklistsReg', (checklistRegFromLocalStorage && checklistRegFromLocalStorage != 'null') ? checklistRegFromLocalStorage : JSON.stringify(checklistRegList));
            window.open(`${window.location.origin}/checkListRegistrados`, "_blank");
        }else{
            navigate('/checkListRegistrados',{state:{CKtoFind:`"${p.codChecklistReg} - ${p.nroChecklistReg}"`}})
        }
    }

    const handleMultipleProcsChecked = (e,proc) => {
        e.stopPropagation();

        if(proc.originado == 'CHECKLIST'){
            Swal.fire({
                title:'Ops!',
                text:"No se pueden incluir procedimientos por controles fallidos en una selección múltiple.",
                icon:'error'
            })
            return;
        } 
            

        setProcsToCreateODT(prevProcs => {
            let newProcs = prevProcs.slice();
            if(newProcs?.some(p => p._id == proc._id)) newProcs = newProcs?.filter((p => p._id != proc._id));
            else{
                if(newProcs.length == 0 || newProcs?.some(p => p.activoID == proc.activoID)) newProcs?.push(proc);
                else Swal.fire({
                    title:'Ops!',
                    text:"No se pueden seleccionar procedimientos de distintos activos.",
                    icon:'error'
                })
            } 
            return newProcs;
        });
    }

    const handleNoDispararProcedimiento = async (p) => {
        try {
            const res = await checkProcProgramado(p._id);
            if(!res.data.exists){
                setProcsProgramados(prev => prev.filter(proc => proc._id !== p._id));
                Swal.fire({title:'Ops!', text:'Otro administrador estableció que este checklist no disparará procedimientos.', icon:'error'});
                return;
            }
            const updatedProc = res.data.data;
            if(updatedProc.NroForOT > 0){
                setProcsProgramados(prev => prev.map(proc => proc._id === p._id ? updatedProc : proc));
                Swal.fire({title:'Una orden de trabajo ya se generó sobre este procedimiento', text:'Parece que alguien ya tomó medidas sobre este procedimiento! Actualizando procedimiento....', icon:'info'});
                return;
            }
            Swal.fire({
                title: '¿Está seguro?',
                text: 'El procedimiento sera borrado, esto es irreversible.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, borrar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if(result.isConfirmed){
                    try {
                        await deleteProcProgramado(p._id);
                        setProcsProgramados(prev => prev.filter(proc => proc._id !== p._id));
                        Swal.fire('Eliminado', 'El procedimiento fue eliminado correctamente.', 'success');
                    } catch (error) {
                        Swal.fire('Error', 'No se pudo eliminar el procedimiento.', 'error');
                    }
                }
            });
        } catch (error) {
            Swal.fire('Error', 'No se pudo verificar el procedimiento.', 'error');
        }
    }

    const uniMedToString = unimed => (unimed == 'KM') ? 'Kilómetros' : (unimed == 'HS') ? 'Horas' : 'Días';

    // Determina si la unidad secundaria fue la que disparó el procedimiento
    const getDisplayValues = (p) => {
        const primaryTriggered = p.valorLecturaAlerta && p.valorLecturaUltima && p.valorLecturaAlerta <= p.valorLecturaUltima;
        const secondaryTriggered = p.uniMed2 && p.valorLecturaAlerta2 && p.valorLecturaUltima2 && p.valorLecturaAlerta2 <= p.valorLecturaUltima2;

        if(!primaryTriggered && secondaryTriggered){
            return {
                uniMed: p.uniMed2,
                valorLecturaUltima: p.valorLecturaUltima2,
                valorLecturaVencimiento: p.valorLecturaVencimiento2,
                valorLecturaAlerta: p.valorLecturaAlerta2,
                incrementoDesdeUltCompletado: p.incrementoDesdeUltCompletado2
            };
        }
        return {
            uniMed: p.uniMed,
            valorLecturaUltima: p.valorLecturaUltima,
            valorLecturaVencimiento: p.valorLecturaVencimiento,
            valorLecturaAlerta: p.valorLecturaAlerta,
            incrementoDesdeUltCompletado: p.incrementoDesdeUltCompletado
        };
    };

    return <div className="procsProgramadosListDiv">
        {procProgramadosFiltered.map((p,i) => { const dv = getDisplayValues(p); return <div className="rrProcsProgramadosDiv" key={i}>
            <div className="rrHeader">
                <h4>{p.codProc} - {p.codActivo}</h4>
                <h4>{p.nameProcedimiento} / {p.nameActivo}</h4>
                <h4 className={(p.tipoAlerta == 'VENC') ? 'alertaVENC' : 'alertaPorVENC'} id="h4Alerta">{(p.tipoAlerta == 'VENC') ? 'Vencido' : 'Por Vencer'}</h4>
                <h4 id="h4Estado">Estado: {(p.state == 'COMPL') ? <>Completado<FontAwesomeIcon icon={faCheck} className="rrIcon" id="complIcon"/></> : (p.state == 'PEND') ? <>Pendiente<FontAwesomeIcon icon={faClock} className="rrIcon" id="pendIcon"/></> : <>En Progreso<FontAwesomeIcon icon={faSpinner} className="rrIcon" id="progIcon"/></>}</h4>
            </div>
            <div className="rrBody">
                <div className="firstRow">
                    {Boolean(dv.incrementoDesdeUltCompletado && dv.uniMed != 'DAYS' && dv.incrementoDesdeUltCompletado > 0) && <label>{uniMedToString(dv.uniMed)} desde Ult. Completado: {dv.incrementoDesdeUltCompletado}</label>}
                    <label>Valor Última Lectura: {dv.valorLecturaUltima}</label>
                    <label>Valor Vencimiento: {dv.valorLecturaVencimiento}</label>
                    <label>Valor Alerta: {dv.valorLecturaAlerta}</label>
                    {(p.diasFSERVDesdeUltCompletado > 0) && <label>Dias Fuera Servicio desde Ult. Completado: {p.diasFSERVDesdeUltCompletado}</label>}
                    <label></label>
                </div>
                <div className="secondRow">
                    <label>Fecha de Alta: {new Date(p.fecAlt).toLocaleString('es-AR', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        second: 'numeric',
                        hour12: true
                    })}</label>
                    <label>Unidad Medida: {uniMedToString(dv.uniMed)}</label>
                    <label>CodFor ODT: {p.CodForOT}</label>
                    <label>NroFor ODT: {(p.NroForOT != 0) ? p.NroForOT : ''}</label>
                </div>
            </div>
            <div className="rrButtonsDiv">
                {/* {(p.originado == 'CHECKLIST' && p.state == 'PEND' && checkIfAdminOrAdminNoABMs()) && <button onClick={()=>handleNoDispararProcedimiento(p)} id="noDispararButton">No disparar procedimiento</button>} */}
                
                {
                    (p.state == 'PEND' && checkIfAdminOrAdminNoABMs()) 
                    ? 
                    <button onClick={()=>generarOT(p,'new')} id="generarODTButton">
                        Generar ODT 
                       
                        <div>
                         <input onClick={e => handleMultipleProcsChecked(e,p)} checked={procsToCreateODT?.some(odt => odt._id == p._id)} className="selectMultipleProc" type="checkbox"/>
                        </div>
                    </button>
                    : 
                    (p.state == 'PROG' && checkIfAdminOrAdminNoABMs()) && <button onClick={()=>generarOT(p,'edit')}>{`Editar ODT ${p.NroForOT}`}</button>
                }

                {(p.originado == 'CHECKLIST' && p.state == 'PEND' && checkIfAdminOrAdminNoABMs()) &&<div className='r-list-item-btn-A' id="deleteODT" onClick={() => handleNoDispararProcedimiento(p)}>Eliminar</div>}
                
                {p.NroForOT != 0 && <button onClick={()=>visualizarOT(p)}>{`Ver ODT ${p.NroForOT}`}</button>}
                
                {(p.nroChecklistReg != 0 && p.nroChecklistReg != undefined && checkIfAdminOrAdminNoABMs()) && <button onClick={()=>visualizarChecklist(p)}>{`Ver ${p.codChecklistReg}-${p.nroChecklistReg}`}</button>}
            </div>
        </div>})}
        {Object.keys(procCtrlsFallidos).length > 0 && <ModalForm docToEdit={procCtrlsFallidos} formToShow="ctrlsFallidos" minimizar={()=>setProcCtrlsFallidos({})}/>}
    </div>
}

export default ProcsProgramadosList;